/**
 * "You are seeing this as someone else" — said loudly, at the top, always.
 *
 * IT IS NOT DISMISSIBLE, and that is the design. The failure mode this
 * prevents is someone forgetting they are impersonating and reading another
 * person's screen as their own — every minute of which is recorded against
 * their name. A banner you can close is a banner that will be closed.
 *
 * Hidden when the target is a club user (not Priori staff): impersonating
 * into a club account is the demo path, and the yellow bar across the top
 * ruins the view. Staff-to-staff impersonation keeps the banner.
 *
 * Yellow, not red: nothing is wrong. This is a state to be aware of, which is
 * what the flagged token means everywhere else in the product.
 */
import { X } from 'lucide-react'

export default function ImpersonationBanner({ target, actor, onStop, isTargetStaff }: {
  target: { id: number; email: string }
  actor: { id: number; email: string } | null
  onStop: () => void
  /** When impersonating a club user (for demos), the banner hides so the
   *  demo view is clean. Staff-to-staff impersonation keeps it visible. */
  isTargetStaff?: boolean
}) {
  if (isTargetStaff === false) return null
  return (
    <div className="imp-banner" role="status">
      <span className="imp-banner__text">
        You are viewing Priori as <strong>{target.email}</strong>
        {actor ? <> — signed in as {actor.email}</> : null}. This session is
        recorded in the audit log.
      </span>
      <button className="imp-banner__stop" onClick={onStop}>
        Return to my account <X size={14} />
      </button>
    </div>
  )
}
